import React, { Component, useEffect, useState } from 'react'; 
import Image from 'next/image';
import IMAGES from '@/public/assets/img';
import { SEODATA } from '@/config/seo_config';
import AOS from 'aos';
import 'aos/dist/aos.css';
import loadable from '@loadable/component';
import Link from 'next/link';
import Head from "next/head";


export const metadata = {
    title: SEODATA.CAREERS.title,
    description: SEODATA.CAREERS.description,
    alternates: {
      canonical: SEODATA.CAREERS.url
    },
    
    openGraph: {
      title: SEODATA.CAREERS.title,
      description: SEODATA.CAREERS.description,
      url: SEODATA.CAREERS.url,
    }
  };


const CareerPage = () =>{   
    const [mWidth, setMWidth] = useState(0)
    const handleWindowResize = () => {
      setMWidth(window.innerWidth);
    }
    useEffect(() => {
        handleWindowResize();
        window.addEventListener('load', handleWindowResize);
        // unsubscribe from the event on component unmount
        return () => window.removeEventListener('resize', handleWindowResize);
        // return () => clearTimeout(timeId);
      }, []); 
      useEffect(() => {
        AOS.init();
      }, []); 
    return(
        <main>
                <Head>  
                    <title>{metadata.title}</title>
                    <meta name="description" content={metadata.description} />
                    {/* OpenGraph tags */} 
                    <meta property="og:title" content={metadata.openGraph.title} />
                    <meta property="og:description" content={metadata.openGraph.description} />
                    <meta property="og:url" content={metadata.openGraph.url} />
                    <link rel="canonical" href={metadata.alternates.canonical} />
                    {mWidth > 767 ?
                     <link rel="preload" as="image" href={IMAGES.CAREERIMG.banner.src}/>:
                     <link rel="preload" as="image" href={IMAGES.CAREERIMG.banner_mb.src}/>}
                </Head>
            
                <section className="bg-white sm:h-auto h-[75vh] md:h-[70vh] sm:py-20 min-h-[650px] md:min-h-[500px] sm:min-h-[667px] sm:pt-[120px] sm:pb-0">
                        <div className='container  lg:px-3 h-full px-3 xm:px-2'>
                            <div className='flex h-full sm:flex-col items-center md:items-center justify-between'>
                                <div className='w-2/5 md:w-1/2 sm:w-full' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                                    <div className='homebannertop'>
                                        <h1 className='text-heading2 md:text-xl sm:text-xl text-brand font-bold mb-3'>
                                        Discover your potential at one of the leading fintechs in the industry</h1>
                                        <p className='text-base text-brand leading-6'> At Credlix, we unlock the potential of people, businesses and communities. We’re here to fix the cash flow problems through a digital platform that businesses face in the supply chain ecosystem. So, if you’re looking for a platform to create an impact with your exceptional problem-solving skills and subject knowledge, then Credlix is the right place for you. </p>
                                        <a href="https://moglix.flexiele.com/careers/moglix/jobs" target="_blank" rel="noopener noreferrer" className='mt-5 inline-block text-white text-sm py-2 px-3 rounded-xl font-bold cursor-pointer bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C] '>Explore Opportunities</a>
                                    </div>
                                </div>
                                <div className='w-3/5 md:w-1/2 flex sm:w-full items-end' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                                {mWidth > 767 ?   
                                 <Image priority={true} fetchPriority='high' className='w-[70%] flex ml-auto' src={IMAGES.CAREERIMG.banner} alt=" Credlix Careers"/>
                                 :
                                 <Image priority={true} fetchPriority='high' className='w-full sm:mt-6' src={IMAGES.CAREERIMG.banner_mb} alt=" Credlix Careers"/>
                                }
                                  
                                </div>
                            </div>
                        </div>
              
            </section>      
            <section className='bg-[#f5f7fe] py-20'>
                <div className='container h-full  lg:px-3 px-3 xm:px-2'>
                    <div className='text-center' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                            <h2 className='text-xl text-secondary font-medium mb-3'>Why should you join Credlix?</h2>
                            <p className='text-base text-secondary mb-16'>Our powerful core values and attributes serve as the foundation of our mission and vision. These values guide how we work with people within our organization and in the communities we serve.</p>
                        </div>
                        <div className='flex flex-wrap mt-12 -mx-2 sm:flex-col'>
                                <div className='p-2 w-1/4 md:w-1/2 sm:w-full' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                                    <Image loading='lazy' className='sm:m-auto w-full h-auto' src={IMAGES.CAREERIMG.fearless} alt="Fearless" width={288} height={227}/>
                                    <Image loading='lazy'  className='pt-4 sm:m-auto w-full h-auto' src={IMAGES.CAREERIMG.ownership} alt="ownership" width={288} height={294}/>
                                </div>
                                <div className='p-2 w-1/4 md:w-1/2 sm:w-full' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                                    <Image loading='lazy'  className='sm:m-auto w-full h-auto' src={IMAGES.CAREERIMG.agility} alt="agility" width={288} height={294}/>
                                    <Image loading='lazy'  className='pt-4 sm:m-auto w-full h-auto' src={IMAGES.CAREERIMG.customer} alt="customer focus" width={288} height={227}/>
                                </div>
                                <div className='p-2 w-1/4 md:w-1/2 sm:w-full' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                                    <Image loading='lazy'  className='sm:m-auto w-full h-auto' src={IMAGES.CAREERIMG.integrity} alt="agility" width={288} height={227}/>
                                    <Image loading='lazy'  className='pt-4 sm:m-auto w-full h-auto' src={IMAGES.CAREERIMG.innovation} alt="innovation" width={288} height={294}/>  
                                </div>
                                <div className='p-2 w-1/4 md:w-1/2 sm:w-full' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                                    <Image loading='lazy'  className='sm:m-auto w-full h-auto' src={IMAGES.CAREERIMG.collaboration} alt="collaboration" width={288} height={294}/>
                                    <Image loading='lazy'  className='pt-4 sm:m-auto w-full h-auto' src={IMAGES.CAREERIMG.people} alt="people focus" width={288} height={227}/>
                                </div>
                        </div>
                </div>
            </section>  
            <section className='py-20'>
                <div className='container  lg:px-3 px-3 xm:px-2'>
                    <div className='w-full bg-[#e3a32f] py-6 sm:py-3 px-7 md:px-6 sm:px-3 rounded-[10px] flex items-center sm:flex-col' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                        <div className='relative sm:text-center'>
                            <h3 className='text-xl text-white font-medium w-full sm:max-w-full max-w-[58%] md:max-w-[73%]'>Our team is growing and welcoming all fintech enthusiasts. <span className='font-bold'> Are you ready to join us? </span> </h3>
                            <Link href="https://moglix.flexiele.com/careers/moglix/jobs" target="_blank" rel="noopener noreferrer" className='bg-white inline-block text-brand py-2 px-3 font-bold rounded-[10px] absolute right-[-50px] md:right-0 sm:right-0 top-[8px] sm:top-auto sm:relative sm:mt-1 cursor-pointer'> Apply Now </Link>
                        </div>
                    </div>
                </div>
            </section>
      </main>   
    );
    };
    
    export default CareerPage;